<template>
  <div class='image-content-wrapper'>
    <div v-if='isCanceled' class='live-video-meta rec active'>Avlyst!</div>
    <div v-if='isPostponed' class='live-video-meta rec active'>Utsatt!</div>
    <div v-if='time' class='live-video-meta time active'>{{timeValue}}</div>
    <div v-if='live' class='live-video-meta live active'>Direkte</div>
    <div v-if='rec' class='live-video-meta rec active'>Avsluttet</div>
    <img :src='imageSrc' :alt='imageAlt' :title='imageAlt' />
  </div>
</template>

<script>
  import mixins from '../../mixins'
  import lang from '../../lang'

  export default {
    mixins: [mixins],
    name: 'top-image-box-content',
    data () {
      return {
        imageAlt: this.$root.cmsData.mainBlock.imageAltText,
        imageSrc: undefined
      }
    },
    computed: {
      time: function () {
        return this.isActive && this.liveHelper().isPreLive(this.$root.cmsData, this.$root.liveData)
      },
      live: function () {
        return this.isActive && this.liveHelper().isVotingOrActiveWithActiveProceedingOrActiveHearing(this.$root.cmsData, this.$root.liveData)
      },
      rec: function () {
        return this.isActive && false
      },
      timeValue: function () {
        return `${lang.clock[this.$root.cmsData.lang]} ${this.liveHelper().meetingTime(this.$root.cmsData, this.$root.liveData)}`
      }
    },
    props: ['isActive', 'isCanceled', 'isPostponed'],
    created () {
      if (this.live) {
        this.imageSrc = this.$root.cmsData.mainBlock.fallback

        if (this.$root.cmsData.mainBlock.imageSnapshot) {
          this.$http.get(this.$root.cmsData.mainBlock.imageSnapshot).then(response => {
            this.imageSrc = this.$root.cmsData.mainBlock.imageSnapshot
          }, response => {
              // Comment this in for debug purposes, don't want it logging in production.
              // console.log('Failed to get snapshot: ', response)
          })
        }
      } else {
        this.imageSrc = this.$root.cmsData.mainBlock.image
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TopImageBoxContent.vue?34e3bed2